<template>
  <div class="fts-history-log">
    <div v-for="x in getLog" :key="x.id">
      <!-- table -->
      <fts-collapsible-element initial-visible v-if="x.originalDataType == 'table' || x.currentDataType == 'table'">
        <div
          slot="toggle"
          slot-scope="{ isVisible, toggle}"
          class="history-log-item history-log-collapse-header"
          :class="{'history-log-collapse-header--collapsed': isVisible}"
        >
          <div class="history-log-collapse-toggle" @click="toggle">
            <div class="history-log-collapse-toggle-label">
              <span>{{x.DisplayName}}</span>
            </div>
            <font-awesome-icon
              :icon="['fas', 'caret-right']"
              fixed-width
              class="history-log-collapse-toggle-icon"
            />
          </div>
        </div>
        <template #content>
          <template v-if="x.Details && x.Details.length">
            <div v-for="(y, yInd) in x.Details" :key="y.id" class="history-log-detail-content">
              <fts-collapsible-element initial-visible>
                <div
                  slot="toggle"
                  slot-scope="{ isVisible, toggle }"
                  class="history-log-collapse-header"
                  :class="{'history-log-collapse-header--collapsed': isVisible}"
                >
                  <div class="history-log-collapse-toggle" @click="toggle">
                    <div class="history-log-collapse-toggle-label">
                      row {{y.Row? y.Row : (yInd + 1)}} {{getTypeDescription(y.Type)}}
                    </div>
                    <font-awesome-icon v-if="y.Type != 1 && y.Details"
                      :icon="['fas', 'caret-right']"
                      fixed-width
                      class="history-log-collapse-toggle-icon"
                    />
                  </div>
                </div>
                <template #content>
                  <fts-history-log :module-id="moduleId" :log="y.Details" v-if="y.Details"  />
                  <div class="history-log-item" v-else-if="y.Type === 0 || y.type === 2">
                    <span class="history-log-value history-log-value--success">
                      row
                    </span>
                  </div>
                  <div v-else></div>
                </template>
              </fts-collapsible-element>
            </div>
          </template>

          <div class="history-log-detail-content" v-else>
            <span class="history-log-value history-log-value--danger" v-if="!Boolean(x.Current)">
              row(s) removed
            </span>
            <span class="history-log-value history-log-value--success" v-else>
              row(s) updated
            </span>
          </div>
        </template>
      </fts-collapsible-element>
      <!-- default -->
      <div class="history-log-item" v-else>
        <span>{{x.DisplayName}}</span>
        <template v-if="x.Original !== null && x.Original !== undefined">
          <fts-history-log-display
            :module-id="moduleId"
            :information-id="x.InformationId"
            :data-type="x.originalDataType"
            :log="x.Original"
            class="history-log-value history-log-value--danger"
          />
        </template>
        <fts-history-log-display
          :module-id="moduleId"
          :information-id="x.InformationId"
          :data-type="x.currentDataType"
          :log="x.Current"
          class="history-log-value history-log-value--success"
          v-if="isEmpty(x.Original) || (!isEmpty(x.Original) && !isEmpty(x.Current))"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import commons from '../../commons/commons';
import { dateTimeValidator } from '../../commons/validator';

import FTSCollapsibleElement from '../FTSCollapsibleElement';
import FTSHistoryLogDisplay from './FTSHistoryLogDisplay';

export default {
  name: "fts-history-log",
  components: {
    "fts-collapsible-element": FTSCollapsibleElement,
    "fts-history-log-display": FTSHistoryLogDisplay,
  },
  props: {
    moduleId: [String, Number],
    log: Array,
  },
  methods: {
    isEmpty(log) {
      const isEmptyArray = (val) => val && val.length;
      const isEmptyObject = (val) => {
        for(var i in val) return false;
        return true;
      }
      return (
        log === null ||
        log === undefined ||
        log === '' ||
        (commons.isObject(log) && isEmptyArray(log)) ||
        (commons.isArray(log) && isEmptyObject(log))
      );
    },
    getTypeDescription(type) {
      switch(type) {
        case 0:
          return 'added';
        case 1:
          return 'removed';
        default:
          return 'updated';
      }
    }
  },
  computed: {
    getLog() {
      const getDataType = (val) => {
        if (
          commons.isObject(val) && (
            (
              val.hasOwnProperty("lat") &&
              val.hasOwnProperty("lng")
            ) ||
            val.hasOwnProperty("placeName")
          )
        ) {
          return "location";
        } else if (commons.isObject(val) && val.hasOwnProperty('path')) {
          return "file";
        } else if (commons.isArray(val) && val.some(x => x.hasOwnProperty('path'))) {
          return "files";
        } else if (commons.isArray(val) && val.length) {
          return "table";
        } else if (moment(val, moment.ISO_8601).isValid() && dateTimeValidator(val)) {
          return "date";
        } else {
          return "default";
        }
      }
      return this.log && this.log.map(x => ({
        ...x,
        currentDataType: getDataType(x.Current || x.Details),
        originalDataType: getDataType(x.Original || x.Details)
      }));
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.fts-history-log {
  .history-log-item {
    padding: 0.25rem 0.75rem;
    font-size: 0.75rem;
    line-height: 1.125rem;
  }
  .history-log-collapse-header {
    .history-log-collapse-toggle {
      @include user-select-none;
      display: inline-flex;
      align-items: center;
      cursor: pointer;
      .history-log-collapse-toggle-label {
        margin-right: 0.25rem;
      }
      .history-log-collapse-toggle-icon {
        transition: all 0.3s;
      }
    }
    &.history-log-collapse-header--collapsed {
      .history-log-collapse-toggle-icon {
        transform: rotate(90deg);
      }
    }
  }
  .history-log-detail-content {
    margin-bottom: 0.5rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .history-log-value {
    display: inline-flex;
    flex-wrap: wrap;
    padding-left: 0.15rem;
    padding-right: 0.15rem;
    border-radius: 0.15rem;
    line-height: normal;
    &.history-log-value--success {
      background-color: rgba(var(--fts-success-rgb), 0.125);
    }
    &.history-log-value--danger {
      background-color: rgba(var(--fts-danger-rgb), 0.125);
    }
  }
  .history-log-seperator {
    white-space: nowrap;
    color: var(--fts-default);
  }
}
</style>